import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

    }

    init() {

        // this.$controls = this.$('controls')[0];

        this.swiper = new Swiper(this.$('slideshow')[0], {
            loop: true,
            slidesPerView: 1,
            loopedSlides: 3,
            centeredSlides: true,
            preloadImages: false,
            speed: 800,
            navigation: {
                nextEl: this.$('next')[0],
                prevEl: this.$('prev')[0]
            },
            on: {
                slideChange: () => {
                    this.swiper.lazy.load()
                }
            }
        });

    }

    inview(e) {
        if(e.obj.el == this.el) {
            this.swiper.params.lazy.loadPrevNext = true;
            this.swiper.lazy.load()
            this.swiper.autoplay.start()
            this.swiper.params.autoplay.disableOnInteraction = false;
        }
    }

    destroy() {
        this.swiper.destroy()
    }
}
